import {assert} from 'Asserts';
import * as RequestAccessActions from 'auth/RequestAccessActions';
import {parseFolderItemIdFromURL} from 'folder-items/FileUtil';
import navigateToURL from 'lib/navigateToURL';
import notifications, {GenericResponseJSON, ResponseJSON} from 'notifications';
import EntityStore from 'stores/EntityStore';

import {InaccessibleInfoGraphQL} from '../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

export function getArgForRequestAccess(
  object: GenericResponseJSON
): ResponseJSON | InaccessibleInfoGraphQL | null {
  if (object == null) {
    return null;
  } else if (object.status === 404) {
    return object.responseJSON;
  } else if (isInaccessibleInfo(object)) {
    return object;
  } else {
    return null;
  }
}

export function canRequestAccess(json: ResponseJSON | InaccessibleInfoGraphQL): boolean {
  return json && (json as GenericResponseJSON | InaccessibleInfoGraphQL).canRequestAccess;
}

export function requestAccess(json: ResponseJSON | InaccessibleInfoGraphQL): void {
  assert(canRequestAccess(json), 'Expected caller to guard on can RequestAccess');

  if (EntityStore.currentUser() == null) {
    notifications.error('Please log in to request access to this item.');
    return;
  }

  const actionText = 'Request access';
  const id = (json as GenericResponseJSON | InaccessibleInfoGraphQL).invalidId;
  const onActionClick = (): void => {
    RequestAccessActions.requestAccess(id);
    notifications.success('Access requested.');
  };
  notifications.warn(
    'You do not have access to the project or registry associated with this item.' +
      " Requesting access will send an email to the project's administrator(s).",
    {
      actionText,
      onActionClick,
      duration: 0,
      id,
    }
  );
  if (parseFolderItemIdFromURL() === id) {
    navigateToURL('/editor');
  }
}

export interface InaccessibleInfo extends GenericResponseJSON {
  invalidId: string;
  canRequestAccess?: boolean;
}

export function makeInaccessibleInfo(invalidId: string = 'invalid'): InaccessibleInfo {
  return {invalidId, canRequestAccess: false};
}

export function isInaccessibleInfo(info: object): info is InaccessibleInfoGraphQL {
  return 'invalidId' in info;
}
